import React, { useEffect, useState } from "react";
import { CaretRight, CaretDown } from "@phosphor-icons/react";
import {
  SelectedUserPrompt,
  UserPromptVersion,
  UserSavedPrompt,
} from "@Models/types";
import { usePromptToolboxContext } from "@Context/prompt-toolbox/PromptToolboxContext";

interface PromptListProps {
  prompts: UserSavedPrompt[];
  onSelectVersion: (prompt: SelectedUserPrompt) => void;
}

const PromptList: React.FC<PromptListProps> = ({
  prompts,
  onSelectVersion,
}) => {
  const { selectedPromptVersion } = usePromptToolboxContext();

  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [selectedVersion, setSelectedVersion] = useState<{
    promptId: string;
    version: UserPromptVersion;
  } | null>(null);

  useEffect(() => {
    if (selectedPromptVersion) {
      const sel = {
        promptId: selectedPromptVersion.id,
        version: selectedPromptVersion.version,
      };
      setSelectedVersion(sel);
    } else {
      setActiveIndex(null);
    }
  }, [selectedPromptVersion]);

  const togglePromptItem = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleSelectVersion = (
    prompt: UserSavedPrompt,
    version: UserPromptVersion,
  ) => {
    setSelectedVersion({ promptId: prompt.id, version });
    const sel: SelectedUserPrompt = {
      ...prompt,
      versions: prompt.version.map((i) => i.version),
      version,
    };
    onSelectVersion(sel);
  };

  return (
    <>
      {prompts.map((prompt, index) => (
        <div key={prompt.id}>
          <button
          data-testid={`promptList-${prompt.name.replace(/\s+/g, '-')}`}
            onClick={() => togglePromptItem(index)}
            className={`flex w-full items-center justify-between ${
              selectedVersion?.promptId === prompt.id && activeIndex !== index
                ? "rounded-lg bg-primary-700 text-white"
                : activeIndex === index
                  ? "rounded-t-lg bg-primary-700 text-white"
                  : "rounded-lg hover:bg-gray-300"
            } px-4 py-2 focus:outline-none`}
          >
            <span className="font-medium">{prompt.name}</span>
            <span className="transition-transform">
              {activeIndex === index ? (
                <CaretDown weight="bold" />
              ) : (
                <CaretRight weight="bold" />
              )}
            </span>
          </button>
          {activeIndex === index && (
            <div className="rounded-b-lg bg-primary-700">
              <div className="w-full px-2">
                <div className="w-full border border-white"></div>
              </div>

              <div className="p-3 text-white">
                <ul className="space-y-1">
                  {prompt.version.map((version) => (
                    <button
                      data-testid={`promptListVersion${version.version.replace(/\s+/g, '-')}`}
                      onClick={() => handleSelectVersion(prompt, version)}
                      key={version.version}
                      className={`flex w-full flex-row items-center justify-between rounded-full px-3 py-1 ${
                        selectedVersion?.promptId === prompt.id &&
                        selectedVersion?.version.version === version.version
                          ? "bg-white text-black"
                          : "hover:bg-primary-200 hover:text-black"
                      }`}
                    >
                      <label>Version {version.version}</label>
                    </button>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      ))}
    </>
  );
};

export default PromptList;
